import React, { Component } from 'react';
import "../custom.css";
import "../playerAssign.css"
import "bootstrap/dist/css/bootstrap.css";
import AssignmentTable from "./AssignmentTable";
import Modal from './Modal';
import CyberfaceModal from "./CyberfaceModal";



export class PlayerAssignment extends Component {

    constructor(props) {
        super(props);
        this.state = { data: [], loading: true,editPlayer: false,showCyberface: false,rowData:[],images:[],faceCount:'unknown',portraitCount:'unknown' };
    
        this.playerAssignColumns = [
            {
                accessor: 'position',
                Header: 'Position',
                width: 200,
            },
           
            {
            accessor: 'firstName',
            Header: 'First Name',
            defaultCanSort:true
        }, 
        {
            accessor: 'lastName',
            Header: 'Last Name ',
            defaultCanSort:true
        }, 
        {
            accessor: 'photo',
            Header: 'Photo Number',
        }, 
        {
            accessor: 'hash',
            Header: 'Hash',
        }, 
        {
            accessor: 'uniqueCyberface',
            Header: 'UniqueCyberface',
            defaultCanSort:true,
            Cell: ({ cell }) => (
                <button className ="btn-primary" onClick={e=> this.handleCyberface(cell)}>
                    View
                </button>
            )
        },
            {
                accessor: 'nfl2k5team',
                Header: 'Nfl2k5team',
                defaultCanSort:true
            }, 
            {
                accessor: 'nfl2kcurrentPosition',
                Header: 'Nfl2kcurrentPosition',
            }, 
            {
                accessor: 'nfl2kcurrentFirstName',
                Header: 'Nfl2kcurrentFirstName',
                defaultCanSort:true
            }, 
            {
                accessor: 'nfl2kcurrentLastName',
                Header: 'Nfl2kcurrentLastName',
                defaultCanSort:true
            },
            {
                accessor: 'nfl2kcurrentTeam',
                Header: 'Nfl2kcurrentteam',
                defaultCanSort:true
            }, 
            {
                accessor: '',
                Header: 'Edit',
                Cell: ({ cell }) => (
                    <button className ="btn-primary" onClick={e=> this.handleEdit(cell)}>
                      Edit
                    </button>
                  )
            },
           
      ];
   }

    componentDidMount() {
        this.getPlayerAssignments();
    }

    handleEdit = (cell) => {
        console.log(cell?.row?.original);
        this.setState({ editPlayer: true,rowData:cell?.row?.original });
    }

    handleCyberface = (cell) => {

        this.getCyberfacePics(cell?.row?.original);
        this.setState({ showCyberface: true,rowData:cell?.row?.original });
    }

    showModal = e => {
        this.setState({
          editPlayer: !this.state.editPlayer
        });
      };

    showCyberface = e => {
        this.setState({
            showCyberface: !this.state.showCyberface,
            images:[]
        });
    };


    static renderAssignmentTable(playerRecords,playerAssignColumns,faceCount,portraitCount) {
        return (
            <div>
                <h2>Player Assignments</h2>
                <h3>Available Cyberfaces:&ensp;{faceCount}</h3>
                <h3>Available Portraits:&ensp;{portraitCount}</h3>
                <AssignmentTable columns={playerAssignColumns} data={playerRecords} />
                 <br/>
                </div>
        );
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : PlayerAssignment.renderAssignmentTable(this.state.data, this.playerAssignColumns,this.state.faceCount,this.state.portraitCount);

            

        return (
            <div>
                {contents}
                <Modal onClose={this.showModal} isOpen={this.state.editPlayer} playerData={this.state.rowData} />
                <CyberfaceModal onClose={this.showCyberface} isOpen={this.state.showCyberface} playerData={this.state.rowData} playerImages={this.state.images} />
            </div>
        );
    }

    async getPlayerAssignments() {
        const response = await fetch('nflplayerassign');
        const results = await response.json();
        console.log(results);
        this.setState({ data: results});
        const faceCountResponse = await fetch('nflplayerassign/facecount');
        const faceCount = await faceCountResponse.json();

        const portraitCountResponse = await fetch('nflplayerassign/portraitcount');
        const portraitCount = await portraitCountResponse.json();
        this.setState({ faceCount: faceCount, portraitCount: portraitCount,  loading: false });
    }

    async getCyberfacePics(playerData) {
        
        console.log("method did run");
        console.log(playerData);
        const response = await fetch(`nflcyberface/?team=${playerData.nfl2k5team}&position=${playerData.position}&firstname=${playerData.firstName}&lastname=${playerData.lastName}`);
        const results = await response.json();
        console.log(results);
        this.setState({ images: results});
    }
}